import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, NgModule, Output } from '@angular/core';
import { OeAppService } from '../../shared/oe-app.service';
import { TranslatePipeModule } from '../../shared/translate.pipe';
import { TranslationService } from '../../shared/translation.service';
import { WindowService } from '../../shared/window.service';

@Component({
  selector: 'lp2-sign-up-box',
  styleUrls: ['./sign-up-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button *ngIf="!isIpad && !isMobileDevice" (click)="closePanel()" class="btn btn-small btn-light close">
      <span class="close__icon">&times;</span>
    </button>
    <section
      class="w-100 d-flex flex-column"
      [style.align-items]="isIpad ? 'center' : 'start'"
      [style.align-self]="isMobileDevice ? 'flex-start' : 'center'"
    >
      <h6 class="fw-bolder">{{ 'login.signUp.title' | translate }}</h6>
      <p class="mb-3 fs-14 lh-5">
        {{ 'login.signUp.benefitsList' | translate }}
      </p>
      <ul class="fa-ul fs-14 lh-14">
        <li class="lh-6 mb-3">
          <i class="fa fa-check fa-icon-color fs-7 mr-2"></i>{{ 'login.signUp.benefitItem1' | translate }}
        </li>
        <li class="lh-6 mb-3">
          <i class="fa fa-check fa-icon-color fs-7 mr-2"></i>{{ 'login.signUp.benefitItem2' | translate }}
        </li>
        <li class="lh-6 mb-3">
          <i class="fa fa-check fa-icon-color fs-7 mr-2"></i>{{ 'login.signUp.benefitItem3' | translate }}
        </li>
      </ul>
      <div class="sign-up-container">
        <p class="mb-3 fw-bolder fs-14">{{ 'login.signUp.subtitle' | translate }}</p>
        <button
          class="btn btn-signup mb-2 d-flex justify-content-between align-items-center"
          (click)="navigateToLeadForm()"
        >
          {{ 'login.signUp.button' | translate }}
          <i class="fa fa-greater-than fs-xsmall mr-2 ml-4"></i>
        </button>
        <p class="mb-2 fs-14 text-under-button text-lowercase">{{ 'login.signUp.buttonSub' | translate }}</p>
      </div>
    </section>
  `,
  animations: [
    trigger('slideInOut', [transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(100%)' }))])]),
  ],
})
export class SignUpBoxComponent {
  @Output()
  public close: EventEmitter<void> = new EventEmitter();

  @HostBinding('@slideInOut') slideInOut: void;

  constructor(
    private oeAppService: OeAppService,
    private windowService: WindowService,
    private translationService: TranslationService
  ) {}

  public get isIpad() {
    return this.oeAppService.isIpad();
  }

  public get isMobileDevice() {
    return this.oeAppService.isMobileDevice();
  }

  public closePanel(): void {
    this.close.emit();
  }

  navigateToLeadForm() {
    const url = this.translationService.translate('login.signupHref');
    this.windowService.redirectToUrl(url);
  }
}

@NgModule({
  imports: [CommonModule, TranslatePipeModule],
  declarations: [SignUpBoxComponent],
  exports: [SignUpBoxComponent],
})
export class SignUpBoxModule {}



// WEBPACK FOOTER //
// ./ts/app/components/sign-up-box/sign-up-box.component.ts